import { SPECIAL_CHARACTER_VALIDATION, REGEX } from '../constants/enum';
import { API_CODE, API_ERROR_CODES } from '../constants/enum';
export const replaceSpaceAndSpecialCharacter = (text) => {
  return text
    .replace(SPECIAL_CHARACTER_VALIDATION.FOR_SPACE, '-')
    .replace(SPECIAL_CHARACTER_VALIDATION.FOR_NBSP, '')
    .replace(SPECIAL_CHARACTER_VALIDATION.FOR_COMMA, '')
    .replace(SPECIAL_CHARACTER_VALIDATION.FOR_NAMES, '')
    .toLocaleLowerCase();
};

export function convertDate(dateString) {
  const [year, month, day] = dateString.split('-');
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  return `${monthNames[parseInt(month) - 1]} ${day}, ${year}`;
}

export const sendHubspotRequest = (final_data, hubspot_integration) => {
  var xhr = new XMLHttpRequest();
  xhr.open('POST', hubspot_integration);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.send(final_data);
  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4 && xhr.status == API_CODE.STATUS_200) {
      return true;
    } else if (xhr.readyState == 4 && xhr.status == API_ERROR_CODES.STATUS_400) {
      alert(xhr.responseText);
    } else if (xhr.readyState == 4 && xhr.status == API_ERROR_CODES.STATUS_403) {
      alert(xhr.responseText);
    } else if (xhr.readyState == 4 && xhr.status == API_ERROR_CODES.STATUS_404) {
      alert(xhr.responseText);
    }
  };
};

export const replaceWatchWithEmbed = (url) => {
  return url.replace(REGEX?.WATCH, 'embed/');
};
